module.exports = __webpack_public_path__ + "user2/user2-7d6d04ef4a69052cd39d39d38f079bc2.png";